<div class="container">
    <ng-container *ngIf="!confirmAction">
        <div class="top_container">
            <div class="title">{{"deliveryChoice.pickupDeliveryChoice.subtitle" | translate}}</div>
            <img class="quit_cross" src="assets/images/quit_cross.svg" (click)="onNoClick()">
        </div>
        <div class="pickup_container" *ngIf="data.deliveryChoiceResponse">
            <div
                *ngFor="let deliveryPoint of data.deliveryChoiceResponse.deliveryInformation.pickupInformationList; let index = index;">
                <div class="chosenPickup" (click)="select(deliveryPoint)"
                    [ngStyle]="{'background-color' : chosenDeliveryPoint === deliveryPoint? '#F1F1F1': '#F9F9F9'}">
                    <div class="border"
                        [ngStyle]="{'background-color' : chosenDeliveryPoint === deliveryPoint? '#EE7203': '#F9F9F9'}">
                    </div>
                    <div class="one_pickup_container">
                        <app-pickup-point class="one_pickup" [data]="data" [index]="index + 1"
                            [deliveryPoint]="deliveryPoint" [chosenDeliveryPoint]="chosenDeliveryPoint"
                            [refDeliveryinformation]="transformIntoRefComponent(deliveryPoint)"
                            (validatePickup)="validatePickup($event)" (selectPickup)="selectPickup($event)">
                        </app-pickup-point>
                    </div>
                </div>
            </div>
        </div>
        <div class="buttons_container">
            <div class="validate modify" (click)="modifyChoiceDate()" *ngIf="this.data.isModify">
                {{"button.modify" | translate}}</div>
            <div class="validate" *ngIf="isPickupSelected" (click)="isPickupSelected? saveChoices():''"> {{
                "deliveryChoice.pickupDeliveryChoice.button_title" | translate}}
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="confirmAction && !choiceConfirmed">
        <app-validate-choice [chosenPickup]="chosenDeliveryPoint"
            [email]="data.deliveryChoiceResponse.consigneeInformation.email" [validateAction]="validateChoice" [modifyAction]="modifyChoice">
        </app-validate-choice>
    </ng-container>
    <ng-container *ngIf="choiceConfirmed">
        <app-confirm-bloc message1="confirmation_block.delivery_confirmation.message" [dialogRef]="dialogRef"
            [tag]="data.tag" tagPageName="reprogrammation_hors_domicile_confirmation">
        </app-confirm-bloc>
    </ng-container>
</div>